import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { CompanySubscription } from 'models';

import { ProfileNotice } from 'components/company-profile/components/ProfileNotice';

const UpgradeSuccesNotice = () => {
    const router = useRouter();
    const [show, setShow] = useState(false);

    useEffect(() => {
        const { subscription, ...updatedQuery } = router.query;

        if (subscription === CompanySubscription.PREMIUM) {
            setShow(true);

            const newPath = {
                pathname: router.pathname,
                query: updatedQuery,
            };

            router.replace(newPath, undefined, { shallow: true }).then();
        }
    }, [router]);

    if (!show) {
        return null;
    }

    return (
        <ProfileNotice title="Congratulations!" color="brand">
            Your subscription has been upgraded!
        </ProfileNotice>
    );
};

export { UpgradeSuccesNotice };
